<div class="border">
  <div class="row">
    <div class="col-sm-3">
      <!-- <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormCarro">
            <mat-label>TipoCarro</mat-label>
            <mat-select required name="TipoCarro" formControlName="TipoCarro">
              <mat-option>Seleccionar</mat-option>
              <mat-option value="TC01">Furgón</mat-option>
              <mat-option value="TC02">Góndola</mat-option>
              <mat-option value="TC03">Tolva</mat-option>
              <mat-option value="TC04">Tanque</mat-option>
              <mat-option value="TC05">Plataforma Intermodal</mat-option>
              <mat-option value="TC06">Plataforma Especializada</mat-option>
              <mat-option value="TC07">Plataforma Automotriz</mat-option>
            </mat-select>
          </mat-form-field> -->
      <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormCarro">
        <mat-label>TipoCarro </mat-label>
        <input matInput aria-label="State" matInput formControlName="TipoCarro"
          [matAutocomplete]="autoTipoCarro">
        <span class="text-danger"
          *ngIf="FormCarro.controls.TipoCarro.invalid && FormCarro.controls.TipoCarro.touched">
          Campo requerido
        </span>
        <mat-autocomplete #autoTipoCarro="matAutocomplete" [displayWith]="displayTipoCarro">
          <mat-option *ngFor="let item of opcionesTipoCarro | async" [value]="item.id" style="height: 35px;">
            <span> {{item.attributes?.clave}} - {{item.attributes?.tipoCarro}}</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div class="col-sm-3">
      <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormCarro">
        <mat-label>MatriculaCarro</mat-label>
        <input required name="MatriculaCarro" matInput formControlName="MatriculaCarro">
        <mat-error *ngIf="FormCarro.get('MatriculaCarro').invalid && FormCarro.get('MatriculaCarro').touched">
          Campo requerido
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-sm-3">
      <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormCarro">
        <mat-label>GuiaCarro <span style="color:red;">*</span></mat-label>
        <input name="GuiaCarro" matInput formControlName="GuiaCarro">
        <mat-error *ngIf="FormCarro.get('GuiaCarro').invalid && FormCarro.get('GuiaCarro').touched">
          Campo requerido
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-sm-3">
      <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormCarro">
        <mat-label>ToneladasNetasCarro <span style="color:red;">*</span></mat-label>
        <input type="number" name="ToneladasNetasCarro" matInput formControlName="ToneladasNetasCarro">
        <mat-error *ngIf="FormCarro.get('ToneladasNetasCarro').invalid && FormCarro.get('ToneladasNetasCarro').touched">
          Campo requerido
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-1">&nbsp;</div>
    <div class="col-sm-11">
      <h5>Contenedor</h5>
    </div>
    <div class="col-sm-1">&nbsp;</div>
    <div class="col-sm-11">
      <div class="row justify-content-start align-items-center barraGestorPagos mt-4">
        <div class="col-sm-12 col-md-1 col-xl-1">
          <button (click)="addContenedor()" mat-flat-button color="primary">
            <mat-icon svgIcon="heroicons_outline:plus-sm"></mat-icon>
          </button>
        </div>
        <div class="col-sm-12 col-md-1 col-xl-1">
          <button (click)="removeContenedor()" [disabled]="removeDisabledContenedor" mat-flat-button color="warn">
            <mat-icon svgIcon="heroicons_outline:minus-sm"></mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="col-sm-1">&nbsp;</div>
    <div class="col-sm-11">
      <app-contenedor *ngFor="let p of countContenedor" [id]="p" [contenedor]="p.data"></app-contenedor>
      <hr>
    </div>
  </div>
</div>